/**************
 Mobile Nav
 ***************/

// sticky header
function addIsStickyToHeader() {
    if (window.scrollY > 20) {
        document.querySelector("#header").classList.add("isSticky");

        // clean up listener
        window.removeEventListener("scroll", addIsStickyToHeader);
    }
}

// add sticky listener
window.addEventListener('scroll', addIsStickyToHeader);

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdownToggle").forEach(element => {
    element.addEventListener("click", function () {
        this.classList.toggle("active");
    });
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#slider"));

/**************
 Search
 ***************/

// Setup customer service link
document.querySelector(".searchResultsLinksGroupListItemLink[href='#customer_service_widget']").addEventListener("click", function (e) {
    e.preventDefault();
    GorgiasChat.open();
});

// Mobile search button click
document.querySelector("#headerIconsSearch").addEventListener("click", async function () {
    // toggle no scroll
    document.body.classList.toggle("noScroll");

    // show search
    document.querySelector("#searchResults").classList.toggle("active");
});

// Predictive Search
document.querySelector("#headerSearchInput").addEventListener("keyup", async function (event) {
    document.querySelector("#searchResults").classList.toggle("active", event.target.value.length > 0);

    // get results
    const products = await predictiveSearch(event.target.value);

    // setup results
    setupSearchResults(products);
});

document.querySelector("#searchResultsFormInput").addEventListener("keyup", async function (event) {
    // Sync up other input since it's used in our predictiveSearch function
    document.querySelector("#headerSearchInput").value = event.target.value;

    // get results
    const products = await predictiveSearch(event.target.value);

    // setup results
    setupSearchResults(products);
});

// Setup search results
function setupSearchResults(products) {
    const htmlParser = new DOMParser();

    const sectionDocument = htmlParser.parseFromString(products, "text/html");

    const searchProducts = document.querySelector("#searchResultsProducts");

    // clear search product
    searchProducts.innerHTML = "";

    if (!products || sectionDocument.querySelectorAll(".collectionItem")?.length === 0) {
        // Toggle empty state
        document.querySelector("#searchResultsEmpty").classList.add("active");
        document.querySelector("#searchResultsProducts").classList.remove("active");
        return;
    }

    // get all collection items and add event listeners
    sectionDocument.querySelectorAll(".collectionItem").forEach((el) => {
        // Attach quick add event listeners
        el.querySelectorAll(".collectionItemImageQuickAddSize").forEach((button) => {
            button.addEventListener("click", handleQuickAdd);
        });

        el.querySelectorAll(".collectionItemQuickAddSize").forEach((button) => {
            button.addEventListener("click", handleQuickAdd);
        });

        // Attach wish list listener
        el.querySelectorAll(".collectionItemImageFavorite").forEach(button => {
            button.addEventListener("click", handleCollectionItemFavorite)
        });
    });

    if (sectionDocument.querySelector("#searchResultsProducts")) {
        // append result products
        searchProducts.appendChild(sectionDocument.querySelector("#searchResultsProductsGrid"));
        searchProducts.appendChild(sectionDocument.querySelector("#searchResultsProductsShopAllLink"));
    }

    // Toggle product results
    document.querySelector("#searchResultsProducts").classList.toggle("active", sectionDocument.querySelector("#searchResultsProducts"));

    // Toggle empty state
    document.querySelector("#searchResultsEmpty").classList.toggle("active", sectionDocument.querySelector("#searchResultsEmpty"));
}

// Predictive search API
async function predictiveSearch(query) {
    if (!query) {
        return "";
    }

    const req = await fetch(`${window.Shopify.routes.root}search/suggest?q=${query}&resources[limit]=4&resources[type]=product&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title&&section_id=section-predictive-search`);

    // return results
    return await req.text();
}

// log query to GTM every 1 second if the search is different
let lastQuery = "";
setInterval(() => {
    // get new query
    const query = document.querySelector("#headerSearchInput").value;

    // if query is the same, exit
    if (query === lastQuery) {
        return;
    }

    // push to GTM
    dataLayer.push({
        event: "header_search",
        query: query
    });

    // set last query
    lastQuery = query;
}, 2000);